import React, { Component } from 'react';

import Inner from './Inner';
import FooterTagline from './FooterTagline';
import FooterMenu from './FooterMenu';

export default class Footer extends Component {

  render() {
    const {
      isApp
    } = this.props;
    return (
      <footer>
        <FooterTagline/>
        <div className="footer">
          <Inner>
            <div className="footerContainer">
              <div className="footerContent">
                <div className="footerOffices">
                  <address className="footerOffice">
                    <h6 className="footerOfficeTitle">Aarhus</h6>
                    <span className="footerOfficeStreet">Europaplads 8</span>
                    <span className="footerOfficeZip">8000 Aarhus C</span>
                  </address>
                  <address className="footerOffice">
                    <h6 className="footerOfficeTitle">København</h6>
                    <span className="footerOfficeStreet">KALVEBOD BRYGGE 32</span>
                    <span className="footerOfficeZip">1560 København V</span>
                  </address>
                  <address className="footerOffice">
                    <h6 className="footerOfficeTitle">Grønland</h6>
                    <span className="footerOfficeStreet">Issortarfimmut 7</span>
                    <span className="footerOfficeZip">3900 Nuuk</span>
                  </address>
                </div>
                <div className={"footerContact footerContactDesktop"}>
                  <span className="footerContactInfo"><span>CVR:</span>6495&zwj;2811</span>
                  <span className="footerContactInfo"><span>@:</span>
                    <a href="mailto:fristberegneren@poulschmith.dk">fristberegneren@poulschmith.dk</a>
                  </span>
                  <span className="footerContactInfo"><span>T:</span>
                    <a href="tel:+4533152010">+45 33 15 20 10</a>
                  </span>
                </div>
              </div>
              <FooterMenu isApp={isApp} />
              <div className={"footerContact footerContactMobile"}>
                <span className="footerContactInfo"><span>CVR:</span>6495&zwj;2811</span>
                <span className="footerContactInfo"><span>@:</span>
                  <a href="mailto:fristberegneren@poulschmith.dk">fristberegneren@poulschmith.dk</a>
                </span>
                <span className="footerContactInfo"><span>T:</span>
                  <a href="tel:+4533152010">+45 33 15 20 10</a>
                </span>
              </div>
            </div>
          </Inner>
        </div>
      </footer>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js